import { render, staticRenderFns } from "./RepliesLog.vue?vue&type=template&id=2f7d6a64&scoped=true&"
import script from "./RepliesLog.vue?vue&type=script&lang=ts&"
export * from "./RepliesLog.vue?vue&type=script&lang=ts&"
import style0 from "./RepliesLog.vue?vue&type=style&index=0&id=2f7d6a64&prod&scoped=true&lang=css&"
import style1 from "./RepliesLog.vue?vue&type=style&index=1&id=2f7d6a64&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7d6a64",
  null
  
)

export default component.exports